import { useState, useEffect } from 'react';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mdz_token');
    if (token) {
      // Basic expiry check
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem('mdz_token');
        }
      } catch {
        localStorage.removeItem('mdz_token');
      }
    }
    setLoading(false);
  }, []);

  const logout = () => {
    localStorage.removeItem('mdz_token');
    setIsAuthenticated(false);
  };

  return { isAuthenticated, loading, logout };
}
